import React, { useState } from 'react'
import { push } from '@lagunovsky/redux-react-router'
import { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import ProgressCard from '../../../../components/card/ProgressCard'
import { CONTACT_LINK, PATH_REFERENCIAL, PATH_REFERENCIAL_CONTACT, PATH_REFERENCIAL_CONTACTS_GROUP_NEW, PATH_REFERENCIAL_RPQS_LINK } from '../../../../home/constants/RouteConstants'
import ContactAction from '../actions/ContactAction'
import useTitle from 'utils/customHook/useTitle'
import useActions from 'utils/customHook/useActions'
import SearchTable from 'referencial/components/SearchTable'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'

const headers = ['id', 'name', 'numberOfMembers']

const ContactsGroupsApp = ({ rpqs }) => {
    const {
        contactsGroups,
    } = useSelector(store => ({
        contactsGroups: store.ContactReducer.contactsGroups,
    }), shallowEqual)

    const [dataLoaded, setDataLoaded] = useState(false)
    const [exportData, setExportData] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(ContactAction.fetchContactsGroups()).then(() => setDataLoaded(true))
    }, [])

    useTitle(() => {
        if (rpqs) {
            return [{
                title: i18n.rpqs,
                href: 'rpqs',
            }, {
                title: i18n.RPQSReferencials,
                href: PATH_REFERENCIAL_RPQS_LINK,
            }, {
                title: i18n.contactsGroups,
                href: PATH_REFERENCIAL_RPQS_LINK + CONTACT_LINK,
            }]
        }
        return [{
            title: i18n.referencials,
            href: PATH_REFERENCIAL,
        }, {
            title: i18n.contactsGroups,
            href: PATH_REFERENCIAL_CONTACT,
        }]
    }, [rpqs])

    useActions(() => {
        return {
            new: () => dispatch(push(rpqs ? `${PATH_REFERENCIAL_RPQS_LINK}contactGroup/new` : PATH_REFERENCIAL_CONTACTS_GROUP_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(exportData, headers),
                        titleFile: i18n.contactsGroups,
                    },
                },
            },
        }
    }, [exportData, rpqs])

    const contactsGroupsFormatted = useMemo(() => contactsGroups.map(val => ({
        id: val.code,
        name: val.name,
        numberOfMembers: `${val.numberOfMembers}`,
    })), [contactsGroups])

    if (!dataLoaded) {
        return <ProgressCard indeterminate />
    }

    return (
        <SearchTable
            title={i18n.contactsGroups}
            sessionKey={REFERENCIAL_TYPE_NAME.contactGroup}
            data={contactsGroupsFormatted}
            setExportData={setExportData}
            headers={headers}
            onClick={contactGroup => dispatch(push(rpqs ? `${PATH_REFERENCIAL_RPQS_LINK}contactGroup/${contactGroup.id}` : `/referencial/contactGroup/${contactGroup.id}/dashboard`))}
        />
    )
}

ContactsGroupsApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default ContactsGroupsApp